import React from 'react'
import PropTypes from 'prop-types'
import { GLOBALS } from '../../utils/Globals'
import './styles.scss'
import { GoTerminal, GoEllipsis, GoDesktopDownload, GoDeviceDesktop  } from "react-icons/go";

export const VirtualMachineConnectionType = ({ type, iconSize }) => {
  let Icon
  let name
  switch (type) {
    case GLOBALS.virtual_machine.connectionType.R.id:
      Icon = GoDesktopDownload
      name = GLOBALS.virtual_machine.connectionType.R.name
      break
    case GLOBALS.virtual_machine.connectionType.S.id:
      Icon = GoTerminal
      name = GLOBALS.virtual_machine.connectionType.S.name
      break
    case GLOBALS.virtual_machine.connectionType.T.id:
      Icon = GoEllipsis
      name = GLOBALS.virtual_machine.connectionType.T.name
      break
    case GLOBALS.virtual_machine.connectionType.V.id:
      Icon = GoDeviceDesktop
      name = GLOBALS.virtual_machine.connectionType.V.name
      break
    default:
      Icon = GoTerminal
      name = GLOBALS.virtual_machine.connectionType.R.name
      break
  }

  return (
    <div className="type-body">
      <div className="w-icon">
        <Icon size={iconSize} />
      </div>
      <span>{name}</span>
    </div>
  )
}

VirtualMachineConnectionType.propTypes = {
  type: PropTypes.string.isRequired,
  iconSize: PropTypes.number,
}
